var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 66,
    viewBox: "0 0 96 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.752 64.8487L51.048 51.0487H21.148L15.444 64.8487H0.171997L28.876 0.44873H43.596L72.392 64.8487H56.752ZM25.932 39.7327H46.356L36.144 15.0767L25.932 39.7327Z",
    fill: "#003E7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4543 65.5847C81.4863 65.5847 77.5303 61.8127 77.5303 56.5687C77.5303 51.2327 81.4863 47.7367 86.4543 47.7367C91.4223 47.7367 95.3783 51.2327 95.3783 56.5687C95.3783 61.8127 91.4223 65.5847 86.4543 65.5847Z",
    fill: "#003E7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqa);
export default __webpack_public_path__ + "static/media/faqa.12d5b1e795d53cb6d7b789ac9ab4a2bd.svg";
export { ForwardRef as ReactComponent };